import { Id } from 'types/definitions'

export interface ProviderMembershipDTO {
  workspace_id: string
  job_capacity: number
}

export enum ProviderStatusDTO {
  Active = 'ACTIVE',
  Decommissioned = 'DECOMMISSIONED',
  Suspended = 'SUSPENDED',
  OnLeave = 'ON_LEAVE',
  Null = 'NULL',
}

export interface ProviderDTO {
  user_public_id: Id
  given_name: string
  family_name: string
  email: string
  phone: string
  picture: string
  workspaces: ProviderMembershipDTO[]
  global_job_capacity: number
  software_experience: string[]
  software_owned: string[]
  supplemental_software_experience: string[]
  years_experience: number
  state_region: string
  active_ptin: boolean
  provider_status: ProviderStatusDTO
  date_created: string
  date_modified: string
}
